import React from 'react';
import { CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface V1SurveyConfirmationProps {
  surveyName: string;
  eventSlug: string;
}

export const V1SurveyConfirmation: React.FC<V1SurveyConfirmationProps> = ({
  surveyName,
  eventSlug,
}) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-sm p-8 text-center">
        <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Thank You!
        </h1>
        
        <p className="text-gray-600 mb-6">
          Your response to "{surveyName}" has been submitted successfully.
        </p>
        
        <div className="space-y-3">
          <button
            onClick={() => navigate(`/surveys`)}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Back to Surveys
          </button>
          
          <button
            onClick={() => navigate(`/${eventSlug}`)}
            className="w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Return to Event
          </button>
        </div>
      </div>
    </div>
  );
};